import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class SectorPerformanceProxy extends ProxyBase {
  getFdiDomestic(params) {
    return this.get('SectorFDIDomesticPerformanceAnalyzer', params)
  }

  getLargeSme(params) {
    return this.get('SectorCompanySizePerformanceAnalyzer', params)
  }

  getListedLarge(params) {
    return this.get('SectorListedLargePerformanceAnalyzer', params)
  }

  sectorDefaultVsicIdPerformanceAnalyzerExport(params) {
    return this.post(
      'SectorDefaultVsicIdPerformanceAnalyzerExport',
      params,
      {},
      'download',
    )
  }

  sectorDefaultVsicIdPerformanceAnalyzerCompareExport(params) {
    return this.post(
      'SectorDefaultVsicIdPerformanceAnalyzerCompareExport',
      params,
      {},
      'download',
    )
  }
}

export default new SectorPerformanceProxy('IndustryAnalysis/')
